import React, { useEffect, useState } from "react";
import {
  Modal,
} from "react-bootstrap";
import PropTypes from "prop-types";
import "./Step.css";
import "./Step3.css";
import "../../assets/css/component.css";
import "../../assets/css/modal.css";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import { useForm } from "react-hook-form";
import { loginUser } from "../../actions/authActions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ResetPassword from "./ResetPassword";
import axios from "axios";
import setAuthToken from "../../utils/setAuthToken";
import { setCurrentUser } from "../../actions/authActions";
import MenuModal from "../Menu/MenuModal";
import { IoEye, IoEyeOff, IoArrowBack } from "react-icons/io5";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Step3 = (props) => {
  const { register, handleSubmit } = useForm();
  const [isResetPassword, setResetPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [isSending, setSending] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [otpSent, setOtpSent] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [showPassword, setShowPassword] = useState(false);
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  // useEffect(() => {
  //   if (props.auth?.userMessage === "Please enter correct password") {
  //     setErrorMsg("Password is incorrect. Please try again.");
  //   }
  // }, [props.auth?.userMessage]);
  useEffect(() => {
    if (props.auth?.userMessage) {
      if (props.auth.userMessage === "Please enter correct password") {
        setErrorMsg("Password is incorrect. Please try again.");
      }
    }
  }, [props.auth]);

  const onSubmit = async (data) => {
    let olddata = { ...props.signInVal, ...data };

    const hasOTP = data.otp && data.otp.trim() !== "";
    const hasPassword = data.password && data.password.trim() !== "";

    if (!hasOTP && !hasPassword) {
      setErrorMsg("Please enter OTP or Password to continue.");
      return;
    }

    if (hasOTP) {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        otp: data.otp,
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        country_code: props?.user?.country_code_value,
      };

      try {
        const res = await axios.post("/auth/verify_otp", payload, {
          headers: { "Content-Type": "application/json" },
        });

        const result = res.data;
        if (result && result.user.access_token) {
          const userData = {
            id: result.user.id,
            username: result.user.username,
            email: result.user.email,
            fname: result.user.first_name,
            lname: result.user.last_name,
            surname: result.user.surname,
            dob: result.user.dob,
            gender: result.user.gender,
            contact_id: result.user.contact_id,
            contactNo: result.user.contact_number,
            address: result.user.address_line_1,
            city: result.user.city,
            zip: result.user.zip_code,
            country: result.user.country,
            user_id: result.user.id,
            profile_image_url: result.user.profile_image_url,
          };

          const returnData = {
            data: {
              user: userData,
              token: result.user.access_token,
              token_expired_at: result.user.expires_at,
            },
          };

          localStorage.setItem("headers", JSON.stringify(returnData));
          setAuthToken(`Bearer ${result.user.access_token}`);
          props.setCurrentUser(returnData);

          olddata.is_otp_verified = true;
          props.loginClicked(olddata);
        } else {
          setErrorMsg(result.message || "OTP verification failed");
        }
      } catch (error) {
        console.error("Error verifying OTP:", error.response?.data || error.message);
        setErrorMsg("OTP verification failed. Please try again.");
      }
      return;
    }

    if (hasPassword) {
      olddata.is_otp_verified = false;
      props.loginClicked(olddata);
      return;
    }
  };

  const sendMobileOTP = async () => {
    try {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
      };

      setSending(true);
      const response = await axios.post("auth/request_otp", payload, {
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;
      setSending(false);

      if (data.success) {
        toast.success("OTP has been sent, you will receive it shortly.");

        setTimeout(() => setAlert(null), 3000);
        setOtpSent(true);
        setOtpTimer(60);

        const timerInterval = setInterval(() => {
          setOtpTimer((prev) => prev - 1);
        }, 1000);

        setTimeout(() => {
          clearInterval(timerInterval);
          setOtpSent(false);
        }, 60000);
      } else {
        setAlert({
          message: data?.message || "Something went wrong, please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setSending(false);
      setAlert({
        message:
          error.response?.data?.message ||
          "Failed to send OTP. Please try again later.",
        type: "error",
      });
      setTimeout(() => setAlert(null), 3000);
    }
  };

  return (
    <>
      <Modal
        show={props.show && !isResetPassword}
        onHide={props.closeModal}
        dialogClassName="s3-dialog"
        contentClassName="s3-content"
        centered
      >
        <MenuModal show={showMenu} closeModal={() => setShowMenu(false)} />

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ---- Alert banner ---- */}
          {alert?.message && (
            <div className={`s3-alert ${alert.type === 'error' ? 's3-alert-error' : 's3-alert-success'}`}>
              {alert.message}
            </div>
          )}

          {/* ---- Back ---- */}
          {props.goBack && (
            <button
              type="button"
              className="s3-back-btn"
              aria-label="Back"
              onClick={props.goBack}
            >
              <IoArrowBack />
            </button>
          )}

          {/* ---- Close ---- */}
          <ModalCloseButton onClick={props.closeModal} />

          <Modal.Body className="s3-body">

            {/* ---- Header ---- */}
            <div className="s3-title">Good to have you back!</div>
            <div className="s3-subtitle">Special deals waiting for you!</div>

            {/* ---- OTP ---- */}
            <label className="s3-section-label">Enter OTP</label>
            <div className="s3-otp-row">
              <input
                type="text"
                autoComplete="off"
                {...register("otp")}
                placeholder="Enter OTP"
                className="s3-otp-input"
                disabled={!otpSent}
                minLength={3}
              />
              <button
                type="button"
                className="s3-send-btn"
                onClick={sendMobileOTP}
                disabled={otpSent || isSending}
              >
                {otpSent ? `Resend in ${otpTimer}s` : isSending ? "Sending…" : "Send OTP"}
              </button>
            </div>

            {/* ---- OR divider ---- */}
            <div className="s3-or">
              <div className="s3-or-line" />
              <span className="s3-or-text">or</span>
              <div className="s3-or-line" />
            </div>

            {/* ---- Password ---- */}
            <label className="s3-section-label">Password</label>
            <div className="s3-pw-wrap">
              <input
                type={showPassword ? "text" : "password"}
                autoComplete="off"
                {...register("password", { onChange: () => setErrorMsg("") })}
                placeholder="Enter your password"
                className="s3-pw-input"
                data-testid="password_input"
              />
              <button
                type="button"
                className="s3-pw-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <IoEye /> : <IoEyeOff />}
              </button>
            </div>

            {errorMsg && <div className="s3-error">{errorMsg}</div>}

            <div
              className="s3-reset-link"
              onClick={() => setResetPassword(true)}
              role="button"
              tabIndex={0}
              onKeyDown={e => { if (e.key === 'Enter') setResetPassword(true); }}
            >
              Reset your password
            </div>

          </Modal.Body>

          <Modal.Footer className="s3-footer">
            <button type="submit" className="s3-login-btn">
              Log in
            </button>
            <div className="s3-powered">Powered by Warely</div>
          </Modal.Footer>

        </form>
      </Modal>

      <ResetPassword
        data={props.signInVal}
        close={props.closeModal}
        show={isResetPassword}
        onHide={() => setResetPassword(false)}
        closeModal={props.closeModal}
        goToLogin={() => setResetPassword(false)}
      />
    </>
  );
};

Step3.propTypes = {
  closeModal: PropTypes.func.isRequired,
  setCurrentUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  login: state,
  loading: state.products.loading,
  user: state.auth.user,
});

export default withTranslation()(
  connect(mapStateToProps, { loginUser, setCurrentUser })(Step3)
);
